var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Schema, type } from "@colyseus/schema";
/**
 * One pre-planned action in a player's private move queue. Lives on `Player`
 * behind `@view()` (like the face-down hand), so only the owning client and
 * the server ever see it — opponents can't read what's coming.
 */
export class QueuedMove extends Schema {
    constructor() {
        super(...arguments);
        /** Which of the owner's upcoming turns this move plays on: 1 = their next
         * turn, 2 = the one after, 3 = the one after that. Slots shift down by one
         * each time the owner's turn starts (slot 1 is extracted and auto-played). */
        this.slot = 1;
        /** Human-readable summary for the queue panel (client-provided). */
        this.label = "";
        /** The `GameAction`, JSON-encoded — schemas can't hold a discriminated
         * union, and the server re-validates it through `dispatchAction` anyway. */
        this.payload = "";
    }
}
__decorate([
    type("uint8")
], QueuedMove.prototype, "slot", void 0);
__decorate([
    type("string")
], QueuedMove.prototype, "label", void 0);
__decorate([
    type("string")
], QueuedMove.prototype, "payload", void 0);
//# sourceMappingURL=QueuedMove.js.map